import React, { useEffect, useState } from 'react';
import { ENTREPRISE } from '../data/site';
import { estAccepte, EVENEMENT } from './consentement';

// La carte n'est chargee que si le visiteur a accepte les contenus tiers,
// ou s'il clique explicitement sur le bouton. Aucune requete vers
// OpenStreetMap tant que l'un des deux n'est pas arrive.
export default function Carte({ hauteur = 260 }) {
  const [chargee, setChargee] = useState(false);

  useEffect(() => {
    setChargee(estAccepte('tiers'));
    const surChangement = (e) => setChargee(Boolean(e.detail && e.detail.tiers));
    window.addEventListener(EVENEMENT, surChangement);
    return () => window.removeEventListener(EVENEMENT, surChangement);
  }, []);

  if (chargee) {
    return (
      <iframe
        title="Situation des bureaux de BATI SELECT TP à Alfortville"
        src="https://www.openstreetmap.org/export/embed.html?bbox=2.404%2C48.798%2C2.436%2C48.812&layer=mapnik&marker=48.805%2C2.420"
        className="w-full border-0 block"
        style={{ height: hauteur }}
      />
    );
  }

  return (
    <div
      className="relative bg-trame flex flex-col items-center justify-center text-center px-6 trame-diagonale"
      style={{ height: hauteur }}
    >
      <p className="font-display uppercase text-[19px] text-nuit">{ENTREPRISE.adresse}</p>
      <p className="font-cond uppercase tracking-[0.1em] text-[14px] text-beton mt-1">
        {ENTREPRISE.codePostal} {ENTREPRISE.ville}
      </p>
      <button
        type="button"
        onClick={() => setChargee(true)}
        className="btn-nuit mt-4 !py-2.5 !px-5 !text-[14px]"
      >
        Afficher la carte
      </button>
      <p className="mt-3 text-[13px] text-beton max-w-xs leading-snug">
        Carte fournie par OpenStreetMap. Elle ne se charge qu'après votre clic, pour ne rien
        déposer sur votre appareil sans votre accord.
      </p>
    </div>
  );
}
